/// <reference path="WebService.ts" />


interface WebService
{
    calculateAccountingJournalEntries( templateType:string, entityID:string, completion:any ) : void ;
    generateAccountingJournalEntries( scope:AccountingJournalGenerationScope, dryRun:boolean, limit:number|null, completion:any ) : void ;
    regenerateJournalEntries( source:CoreAccounting, templateType:string, completion:any ) : void ;
    journalEntrySummary( json:any ) : string ;
}

// What a batch generation covers: one analytic account (its tagged sources), every
// analytic account with rules (analyticAccount null), or a whole domain by event type
// slug ("sales-invoice", "purchase-invoice", "bank-entry").
type AccountingJournalGenerationScope = { analyticAccount?:string|null, eventType?:string };

WebService.prototype.calculateAccountingJournalEntries = function( templateType:string, entityID:string, completion:any ) {
    const url_str = this.apiURL + "/entity/" + this.scheme + "/accounting-journal/" + templateType + "/" + entityID + "/calculate";
    let r = new DLRequest(url_str, null, "POST");
    r.execute( (json:any, error:string) => {
        if (error != null) {
            AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
        }
        if (completion) completion(json, error);
    });
}


// Runs the template rules over every source of the scope without a journal entry.
// dryRun only lists what would be processed (Pending + Items); limit caps the sources
// handled by one call, the response says with HasMore whether another call is needed.
WebService.prototype.generateAccountingJournalEntries = function( scope:AccountingJournalGenerationScope, dryRun:boolean, limit:number|null, completion:any ) {
    let path:string;
    if (scope.eventType != null) {
        path = "/accounting-journal/event-type/" + scope.eventType + "/generate";
    }
    else {
        path = "/accounting-journal/analytic-account/" + (scope.analyticAccount != null ? scope.analyticAccount : "all") + "/generate";
    }
    let params:string[] = [];
    if (dryRun) params.push("dry_run=1");
    if (limit != null && limit > 0) params.push("limit=" + limit);
    const url_str = this.apiURL + "/entity/" + this.scheme + path + (params.length > 0 ? "?" + params.join("&") : "");
    let r = new DLRequest(url_str, null, "POST");
    r.execute( (json:any, error:string) => {
        if (error != null) {
            AppHelper.showErrorMessage( null, MIOLocalizeString("ERROR", "ERROR"), error );
        }
        if (completion) completion(json, error);
    });
}

// Human-readable outcome of a calculate call: lines, debit/credit totals, balance
// and every rule error (one per line).
WebService.prototype.journalEntrySummary = function( json:any ) : string {
    let entries:any[] = json?.Entries ?? [];
    let errors:any[] = json?.Errors ?? [];
    let debit = 0;
    let credit = 0;
    for (let index = 0; index < entries.length; index++) {
        debit += parseFloat(entries[index].DebitAmount ?? 0);
        credit += parseFloat(entries[index].CreditAmount ?? 0);
    }
    let cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter;
    let msg = entries.length + " " + MIOLocalizeString("LINES", "LINES") + ". "
            + MIOLocalizeString("DEBIT", "DEBIT") + ": " + cf.stringFromNumber(debit) + ", "
            + MIOLocalizeString("CREDIT", "CREDIT") + ": " + cf.stringFromNumber(credit);
    if (Math.abs(debit - credit) > 0.005) msg += " (" + MIOLocalizeString("UNBALANCED", "UNBALANCED") + ")";
    for (let index = 0; index < errors.length; index++) {
        msg += "\n- " + (errors[index].Reason ?? errors[index].Kind);
    }
    return msg;
}

// Invoice detail action: recalculates the source's journal entry from the template of
// its domain ("purchase-invoice" / "sales-invoice" / "bank-entry") and reports the outcome.
WebService.prototype.regenerateJournalEntries = function( source:CoreAccounting, templateType:string, completion:any ) {
    this.calculateAccountingJournalEntries( templateType, source.identifier, (json:any, error:string) => {
        if (error == null) {
            AppHelper.showInfoMessage(null, MIOLocalizeString("JOURNAL_ENTRY", "JOURNAL ENTRY") + " #" + (json?.JournalIndex ?? ""), this.journalEntrySummary(json));
        }
        if (completion) completion(json, error);
    });
}
